import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui';

const testimonials = [
  {
    name: 'Mehdi Ben Ali',
    role: 'Expert Comptable, Tunis',
    avatar: 'MB',
    text: 'AccountInTime a révolutionné notre cabinet. La génération TEJ est désormais automatisée et sans erreur. Un gain de temps considérable.',
    rating: 5,
  },
  {
    name: 'Sarra Khemiri',
    role: 'Directrice Financière, Sousse',
    avatar: 'SK',
    text: 'Le module de facturation électronique est tout simplement excellent. Conforme, rapide et facile à utiliser pour toute notre équipe.',
    rating: 5,
  },
  {
    name: 'Amine Bouaziz',
    role: 'Comptable Indépendant, Sfax',
    avatar: 'AB',
    text: 'Je recommande vivement. Le support est réactif et la plateforme évolue constamment pour répondre aux nouvelles exigences fiscales.',
    rating: 5,
  },
  {
    name: 'Leila Jammeli',
    role: 'Cabinet Jammeli & Associés',
    avatar: 'LJ',
    text: 'La vue trésorerie temps réel et le lettrage automatique nous font gagner des heures chaque semaine. Indispensable.',
    rating: 4,
  },
];

export default function TestimonialsCarousel() {
  const [idx, setIdx] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => setIdx((p) => (p + 1) % testimonials.length), 5000);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials[idx];

  return (
    <section className="mb-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="text-4xl font-bold text-white mb-4">Ils nous font confiance</h2>
        <p className="text-slate-400 text-lg max-w-2xl mx-auto">Découvrez ce que nos clients disent de nous</p>
      </motion.div>

      <div className="relative max-w-3xl mx-auto">
        <div className="flex gap-2 justify-center mb-8">
          {testimonials.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)}
              className={`h-2 rounded-full transition-all duration-300 ${i === idx ? 'w-8 bg-indigo-500' : 'w-2 bg-slate-700 hover:bg-slate-500'}`}
            />
          ))}
        </div>

        <motion.div
          key={idx}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
          className="bg-gradient-to-br from-slate-900/60 to-slate-800/30 backdrop-blur-xl border border-slate-700/50 rounded-3xl p-10 text-center"
        >
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-2xl flex items-center justify-center text-white font-bold text-xl mx-auto mb-6 shadow-xl shadow-indigo-500/20">
            {t.avatar}
          </div>
          <div className="flex justify-center gap-1 mb-6">
            {Array.from({ length: 5 }).map((_, i) => (
              <Icon key={i} name={i < t.rating ? 'IconStarFilled' : 'IconStar'} size={20} className={i < t.rating ? 'text-amber-400' : 'text-slate-600'} />
            ))}
          </div>
          <p className="text-slate-200 text-xl leading-relaxed mb-8 italic">&ldquo;{t.text}&rdquo;</p>
          <div>
            <p className="text-white font-bold text-lg">{t.name}</p>
            <p className="text-slate-400 text-sm">{t.role}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
